import { Row, Col } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';
import CustomerInfoPanel from './CustomerInfoPanel';
import AgencyInfoPanel from './AgencyInfoPanel';
import CurrentBenefitsPanel from './CurrentBenefitsPanel';

const BenefitSummaryPanelsRow = ({
  customerProps,
  currentBenefitsProps,
  agencyProps,
  canOverrideAgency = false,
  onOverrideAgency,
  hideAgencyWhenNotAdmin = true,
}) => {
  const { isAdmin } = useAuth();
  const showAgencyPanel = !hideAgencyWhenNotAdmin || isAdmin;

  return (
    <Row>
      <Col md className="pt-3">
        <CustomerInfoPanel {...customerProps} />
      </Col>

      <Col md className="pt-3">
        <CurrentBenefitsPanel {...currentBenefitsProps} />
      </Col>

      {showAgencyPanel && (
        <Col className="pt-3">
          <AgencyInfoPanel
            {...agencyProps}
            canOverride={canOverrideAgency}
            onOverrideAgency={onOverrideAgency}
          />
        </Col>
      )}
    </Row>
  );
};

export default BenefitSummaryPanelsRow;